import {
  GtButton,
  GtInputNumber,
  GtMessage,
  GtDrawer,
  GtImage,
  GtTabs,
  GtTabPane,
  GtForm,
  GtFormItem,
  GtInput
} from '@speedshop/template';
import { Dialog } from 'element-ui';
import { mapGetters } from 'vuex';
import PdtColorPicker from '../components/PdtColorPicker.vue';
import FillBox from '../components/FillBox.vue';
import ImageViewBox from '../components/ImageViewBox.vue';
import PdtCornerLabel from '@/components/PDP/PdtCornerLabel.vue';
import PdtSizePicker from '@/components/PDP/SizePicker.vue';
import { copyText } from '@/utils/tools';

export const PDP = {
  components: {
    GtButton,
    GtInputNumber,
    GtMessage,
    PdtColorPicker,
    PdtSizePicker,
    FillBox,
    ImageViewBox,
    GtDrawer,
    GtImage,
    GtTabs,
    GtTabPane,
    ElDialog: Dialog,
    GtForm,
    GtFormItem,
    GtInput,
    PdtCornerLabel
  },
  inject: ['pdp'],
  data() {
    return {
      visible: false
    };
  },
  computed: {
    ...mapGetters(['isMobile', 'isGuest', 'isLogin'])
  },
  methods: {
    copyText(selector: string) {
      copyText(selector, () => {
        GtMessage.success('复制成功');
      });
    },
    toggleVisible(trackData) {
      this.visible = !this.visible;
      if (trackData) {
        //
        this.$emit('onTrackDetailOperate', trackData);
      }
    }
  }
};
